import {combineReducers} from "redux";
import fleetPreStartReducer from "./reducer";

const reducer = combineReducers({
    fleetPreStartReducer,
})
  
export default reducer;